__turbopack_context__.v({
  "className": "fredoka_ef02c2a9-module__xCl0ga__className",
});
